module.exports = __webpack_public_path__ + "static/media/search-icon.70ad086b.svg";